import StudyEnrollmentForm from './StudyEnrollmentForm';

export default StudyEnrollmentForm;



// WEBPACK FOOTER //
// ./src/views/components/StudyEnrollmentForm/index.js